<template>
    <div>
        <form-build
          ref="repayForm"
          :form-data="form"
          :form-columns-group="formColumnsGroup"
          :form-rules="formRules"
          :form-buttons="formButtons"
          form-name="RepayForm"
          label-width="150px"
          :inline="true"
        ></form-build>
    </div>
</template>

<script>
  import FormBuild from '../../components/FormBuild'
  export default {
    name: "RepayForm",
    data() {
      return {
        formColumnsGroup: [
          {
            label: '还款信息',
            columns: [
              {
                label: '实际还款日期',
                field: 're__repayDate',
                component: 'el-date-picker',
                valueFormat: 'yyyy-MM-dd',
              },
              {
                label: '提前还贷',
                field: 're__advanceRepayment',
                component: 'el-checkbox'
              },
              {
                label: '实收本金',
                field: 're__principalAmount',
                component: 'el-input',
                unit: '元'
              },
              {
                label: '实收利息',
                field: 're__interestAmount',
                component: 'el-input',
                unit: '元'
              },
              {
                label: '实收咨询服务费',
                field: 're__lendingFeeAmount',
                component: 'el-input',
                unit: '元'
              },
              {
                label: '实收逾期利息',
                field: 're__overdueFine',
                component: 'el-input',
                unit: '元'
              },
              {
                label: '提前还贷违约金',
                field: 're__penalyAmount',
                component: 'el-input',
                unit: '元'
              },
              {
                label: '其他费用',
                field: 're__otherAmount',
                component: 'el-input',
                unit: '元'
              },
              {
                label: '减免费用',
                field: 're__deductionAmount',
                component: 'el-input',
                unit: '元'
              },
              {
                label: '合计',
                field: 're__repayAmount',
                span:24,
                unit: '元'
              },
              {
                label: '还款备注',
                field: 're__remarks',
                span:24,
                component: 'el-input',
                type: 'text'
              },
            ]
          }
        ],
        formRules: {
          re__repayDate: [
            {
              required: true,
              message: '实际还款日期不能为空！'
            }
          ]
        },
        formButtons: [
/*          {
            label: '确定',
            type: 'primary',
            clickHandler: ($refs)=>{
              $refs.validate(valid=>{
                if(valid) {
                  this.updateRepayPledgeFinancing()
                }
              })
            }
          },
          {
            label: '取消',
            type: 'danger',
            clickHandler: $refs=>{
              this.dialogDone()
            }
          }*/
        ]
      }
    },
    props: {
      form: {
        type: Object,
        default: ()=>{
          return {
            "re__transactionId": '',
            "re__sequenceNo": "",
            "re__principalAmount": "",
            "re__interestAmount": "",
            "re__lendingFeeAmount": "",
            "re__otherAmount": "",
            "re__overdueDays": "",
            "re__overdueFine": "",
            "re__deductionAmount": "",
            "re__penalyAmount": "",
            "re__advanceRepayment": "",
            "re__repayAmount": "",
            "re__repayDate": "",
            "re__remarks": ""
          }
        }
      }
    },
    components: {
      FormBuild
    },
    watch: {
      form: {
        handler: function(newVal) {
          this.form.re__repayAmount = (Number(this.form.re__principalAmount) || 0) +
            (Number(this.form.re__interestAmount) || 0) +
            (Number(this.form.re__overdueFine) || 0) +
            (Number(this.form.re__lendingFeeAmount) || 0) +
            (Number(this.form.re__otherAmount) || 0) +
            (Number(this.form.re__penalyAmount) || 0) -
            (Number(this.form.re__deductionAmount) || 0)

        },
        deep: true
      }
    },
    methods: {
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/RepayForm.vue